import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalChangePasswordService {
  private displayModal = new BehaviorSubject<boolean>(false);

  constructor() { }

  /**
   * Get the observable for modal visibility state
   */
  get modalState$(): Observable<boolean> {
    return this.displayModal.asObservable();
  }

  /**
   * Open the success modal
   */
  openModal(): void {
    this.displayModal.next(true);
  }

  /**
   * Close the success modal
   */
  closeModal(): void {
    this.displayModal.next(false);
  }

}
